// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__3kV7V","head":"Table_head__OHerc","col":"Table_col__1P0No"};